module.exports = __webpack_public_path__ + "static/media/garage-dispatcher.151e254c.svg";